import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const TrialBanner = () => {
  const { user } = useAuth();
  const access = user?.access;
  if (!access) return null;

  if (access.isTrial)
    return (
      <div data-testid="trial-banner" className="border-b border-primary/40 bg-primary/5">
        <div className="max-w-[1400px] px-4 lg:px-8 py-2.5 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-primary" />
            <span className="font-medium">Free full access trial</span>
            <span className="text-muted-foreground">
              · {access.trialDaysLeft} {access.trialDaysLeft === 1 ? "day" : "days"} left — everything unlocked
            </span>
          </p>
          <Link to="/pricing" data-testid="trial-banner-upgrade">
            <Button size="sm" variant="outline" className="rounded-none">Upgrade early</Button>
          </Link>
        </div>
      </div>
    );

  if (access.trialExpired)
    return (
      <div data-testid="trial-expired-banner" className="border-b border-destructive/40 bg-destructive/5">
        <div className="max-w-[1400px] px-4 lg:px-8 py-2.5 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm flex items-center gap-2">
            <Lock className="h-4 w-4 text-destructive" />
            <span className="font-medium">Your free trial has ended</span>
            <span className="text-muted-foreground">· labs, capstone, interviews and modules 3+ are locked</span>
          </p>
          <Link to="/pricing" data-testid="trial-expired-upgrade">
            <Button size="sm" className="rounded-none">Upgrade to continue</Button>
          </Link>
        </div>
      </div>
    );

  return null;
};

export const UpgradeGate = ({ title, message, testId }) => (
  <div data-testid={testId} className="border border-border p-10 text-center">
    <Lock className="h-5 w-5 mx-auto text-primary" />
    <p className="mt-4 font-display text-lg font-bold">{title}</p>
    <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">{message}</p>
    <Link to="/pricing" className="inline-block mt-6" data-testid={`${testId}-cta`}>
      <Button className="rounded-none">View plans</Button>
    </Link>
  </div>
);
